import template from "./configurations.html";
import controller from "./configurations.controller";

const ConfigurationsComponent = {
	template,
	controller,
	controllerAs: "controller"
};

export default ConfigurationsComponent;


// WEBPACK FOOTER //
// ./sources/components/configurations/configurations-component.js